import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ImagePaths from "../../Utility/ImagePaths";
import { Colors } from "../../Styles/Colors";
import { CurrencySymbol } from "../../Utility/Constants";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

export function ConfirmPopup({
  cnfTitle,
  cnfContent,
  cnfContent1,
  contentBold,
  cnfAlertPopupClose,
  btnText1,
  btnText2,
  btnType = "primary",
  btn1Hide,
  btn2Hide,
  cnfData,
  cnfDisable,
}) {
  const [disableBtn, setDisableBtn] = useState(false);

  const handleClose = () => {
    setDisableBtn(false);
    cnfAlertPopupClose?.();
  };

  const saveData = () => {
    cnfData?.();
    setTimeout(() => setDisableBtn(false), 1500);
  };

  const closeImg = ImagePaths?.LabCloseButton?.default ?? ImagePaths?.LabCloseButton;

  return (
    <Dialog open={true} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" sx={{ "& .MuiDialog-paper": { minWidth: "25vw", maxWidth: "95vw", borderRadius: 1 } }}>
      <Box
        component="div"
        className="eMed_cnf_Box"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          pr: 0.5,
        }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ flex: 1, py: 1.5 }}>{cnfTitle ?? "-"}</DialogTitle>
        <Box component="div" className="eMed_cnf_BtnGr" sx={{ flexShrink: 0 }}>
          {!btn1Hide && (
            <IconButton onClick={handleClose} size="small" sx={{ padding: "0.25vw" }}>
              <img
                className="eMed_DeletePopup_CrossIcon"
                src={typeof closeImg === "object" && closeImg?.default ? closeImg.default : closeImg}
                alt="Close"
              />
            </IconButton>
          )}
        </Box>
      </Box>
      <DialogContent dividers sx={{ width: { xs: "90vw", sm: "60vw", md: "40vw" }, maxWidth: "600px", pt: 1.5 }}>
        {cnfContent && (
          <DialogContentText fontWeight={contentBold} color="#7a7676" id="alert-dialog-description">
            {cnfContent}
          </DialogContentText>
        )}
        {cnfContent1 && (
          <DialogContentText sx={{ fontSize: "0.9dvw", color: "#7a7676" }} id="alert-dialog-description">
            {cnfContent1}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", gap: 1, px: 2, pb: 1.5 }}>
        {!btn1Hide && (
          <Button
            variant="outlined"
            color={btnType}
            sx={{ textTransform: "capitalize" }}
            onClick={handleClose}
          >
            {btnText1 ?? "Cancel"}
          </Button>
        )}
        {!btn2Hide && (
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            disabled={cnfDisable ?? disableBtn}
            onClick={() => {
              setDisableBtn(true);
              saveData();
            }}
          >
            {btnText2 ?? "Confirm"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export function CommonEditButton({ size = "1.3vw", disable, onClick, testID }) {
  const imgSrc = disable ? (ImagePaths.DisabledEdit?.default ?? ImagePaths.DisabledEdit) : (ImagePaths.LabEditButton?.default ?? ImagePaths.LabEditButton);
  return (
    <Tooltip title="Edit" placement="top" arrow>
      <Button emed_tid={testID} className="eMed_Edit_btn eMed_usrconf_btn" disabled={disable} size="small">
        <img src={imgSrc} style={{ height: size, width: size }} alt="Edit" onClick={() => onClick?.()} />
      </Button>
    </Tooltip>
  );
}

export function CommonGridToolBarWithFilterText({
  fromStore,
  isDelete,
  DeleteBtnText,
  removeData,
  myHeight,
  FName,
  FilterTextArray,
  renderComponent,
  noExport,
  onChangingSearch,
  value,
  onChangetrigger,
  searchHolder,
}) {
  return (
    <GridToolbarContainer className="eMed_refdoc_grid" sx={{ flexWrap: "nowrap", height: myHeight || "7vh" }}>
      {isDelete && (
        <Box sx={{ display: "flex", width: fromStore ? "70vw" : "60vw" }}>
          <Button size="small" variant="contained" color="error" sx={{ textTransform: "capitalize" }} onClick={() => removeData?.()}>
            {DeleteBtnText ?? "Delete"}
          </Button>
        </Box>
      )}
      {FName && (
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography fontSize="0.8dvw" color="#888888" marginX="0.3vw">Name: </Typography>
          <Typography fontSize="0.9dvw" color="#616161" marginX="0.3vw" fontWeight={600}>{FName}</Typography>
        </Box>
      )}
      {FilterTextArray?.length > 0 &&
        FilterTextArray.map((list, index) => (
          <Box key={index} display="flex" flexDirection="row" alignItems="center">
            <Typography fontSize="0.8dvw" color="#888888" marginX="0.3vw">{list.label} : </Typography>
            <Typography fontSize="0.9dvw" color="#616161" marginX="0.3vw" fontWeight={600}>{list.value}</Typography>
          </Box>
        ))}
      {renderComponent ? (
        <>
          {renderComponent()}
          <GridToolbarExportContainer>{noExport ? null : <GridCsvExportMenuItem />}</GridToolbarExportContainer>
        </>
      ) : (
        <>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExportContainer>{noExport ? null : <GridCsvExportMenuItem />}</GridToolbarExportContainer>
        </>
      )}
      {onChangingSearch ? (
        <GridToolbarQuickFilter placeholder={searchHolder ?? "Search"} value={value} onChange={(e) => onChangetrigger?.(e.target.value)} />
      ) : (
        <GridToolbarQuickFilter placeholder={searchHolder ?? "Search"} />
      )}
    </GridToolbarContainer>
  );
}

/** Patient details display for lists (name, age/gender, account | mobile). data: { name, patient_age_str, gender, patient_account_number, patients_mobile, ... } */
export function CommonPatientDetails({ data, disablePhoto }) {
  if (!data) return null;
  const patient_name = data.patient_name ?? data.name ?? data.first_name ?? "-";
  const patient_age = data.patient_age_str ?? (data.age?.toString?.()?.includes("Y") ? data.age : data.age ? data.age + "Y" : "-");
  const patient_gender = data.patient_gender ?? data.gender ?? data.patient__gender;
  const whatGender = patient_gender === "Male" || patient_gender === "M" || patient_gender === "m" ? "M" : patient_gender === "Female" || patient_gender === "F" || patient_gender === "f" ? "F" : patient_gender ? "T" : "-";
  const PatientAccNumber = data.patient_account_number ?? data.patient_account_numbers ?? data.uhid ?? data.patient_acc_no ?? "-";
  const mobile_number = data.patients_mobile ?? data.patient_mobile ?? data.mobile_number ?? data.mobile_no ?? "-";
  const photo_url = data.patient_photo_url ?? data.photo_url ?? data.patient__photo_url;
  const displayLine1 = `${patient_name} ${patient_age}${patient_gender ? "/" + whatGender : ""}`.trim();
  const displayLine2 = [PatientAccNumber, mobile_number].filter((x) => x && x !== "-").join(" | ") || "-";

  return (
    <div className="eMed_Com_Patient_Details">
      {!disablePhoto && (
        <div className="eMed_Com_Patient_Avatar">
          <img
            className="eMed_Com_Patient_AvaIcon"
            src={
              photo_url ||
              (patient_gender === "Female" || patient_gender === "F"
                ? (ImagePaths.Female?.default ?? ImagePaths.Female)
                : (ImagePaths.Male?.default ?? ImagePaths.Male))
            }
            alt="Avatar"
          />
        </div>
      )}
      <Box className="eMed_Pateint_Detail_LongData">
        <Typography id="eMed_Com_Patient_Name" sx={{ fontSize: "0.8dvw", textTransform: "uppercase" }}>
          {displayLine1.length > 25 ? (
            <Tooltip title={displayLine1.toUpperCase()} placement="top" arrow>
              <span>{displayLine1.slice(0, 20) + "..."}</span>
            </Tooltip>
          ) : (
            displayLine1
          )}
        </Typography>
        <Typography id="eMed_Com_Patient_UhidText">{displayLine2}</Typography>
      </Box>
    </div>
  );
}

export function DeletePopup({
  DeletTitle,
  DeletContent,
  AlertNote,
  DeleteNotify,
  NotesContent,
  ButtonText,
  ButtonText1,
  deleteAlertPopupClose,
  removeData,
  disable,
  testID: _testID = "test",
  color,
}) {
  const [disableBtn, setDisableBtn] = useState(false);

  const handleClose = () => {
    setDisableBtn(false);
    deleteAlertPopupClose?.();
  };

  const removeFunction = () => {
    removeData?.(false);
    setTimeout(() => setDisableBtn(false), 1500);
  };

  const closeImg = ImagePaths?.LabCloseButton ?? ImagePaths?.LabCloseButton?.default;

  return (
    <Dialog open aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <div style={{ display: "flex", justifyContent: "flex-end", margin: "0.5vw", marginBottom: "0vw" }}>
        <img
          className="eMed_DeletePopup_CrossIcon"
          src={typeof closeImg === "object" && closeImg?.default ? closeImg.default : closeImg}
          alt="Close"
          onClick={handleClose}
        />
      </div>
      <DialogTitle id="alert-dialog-title">{DeletTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: "0.8dvw" }} id="alert-dialog-description">
          {DeletContent ?? ""}
        </DialogContentText>
        {AlertNote !== undefined && (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "0.5vw" }}>
            <div style={{ marginRight: "0.5vw" }} id="alert-dialog-description">
              <ErrorOutlineIcon color="error" fontSize="medium" />
            </div>
            <DialogContentText sx={{ fontSize: "0.9dvw", marginLeft: "0.5vw", fontWeight: 600, color: "red" }} id="alert-dialog-description">
              {AlertNote}
            </DialogContentText>
          </div>
        )}
      </DialogContent>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <DialogContent>
          {DeleteNotify !== undefined && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="eMed_DeletedPopup_bullet"></div>
              <div style={{ fontSize: "0.6dvw", color: "#616161", marginRight: "0.5vw" }} id="alert-dialog-description">
                {ButtonText ? ButtonText : "Remove"}
              </div>
              <div className="eMed_DeletedPopup_Border"></div>
              <DialogContentText sx={{ fontSize: "0.6dvw", marginLeft: "0.5vw", fontWeight: 600, color: color }} id="alert-dialog-description">
                {DeleteNotify}
              </DialogContentText>
            </div>
          )}
          {NotesContent !== undefined && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <DialogContentText sx={{ fontSize: "0.6dvw", marginLeft: "0.5vw", fontWeight: 600, color: color }} id="alert-dialog-description">
                {NotesContent}
              </DialogContentText>
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            color="error"
            size="small"
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            onClick={handleClose}
          >
            {ButtonText1 ?? "Cancel"}
          </Button>
          <Button
            disabled={disable ?? disableBtn}
            color="error"
            size="small"
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            onClick={() => {
              setDisableBtn(true);
              removeFunction();
            }}
          >
            {ButtonText ?? "Remove"}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export const CommonGridHeader = {
  CommonToolBar: ({ fromIPnursenotes, onViewGraphClick }) => (
    <GridToolbarContainer className="eMed_refdoc_grid">
      {fromIPnursenotes && (
        <Button variant="contained" size="small" onClick={onViewGraphClick} style={{ marginRight: "0.6vw" }}>
          View Graph
        </Button>
      )}
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExportContainer>
        <GridCsvExportMenuItem />
      </GridToolbarExportContainer>
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  ),
};

/** Count or amount card (admin4.0 AmountsCard). */
export function AmountsCard(label, amount, count = false, bgcolor = "white", arrow = false, Primary = "white") {
  const Amt = amount != null ? String(amount) : "0";
  const textColor = bgcolor === "white" || bgcolor === "#b4ece4" ? Colors.black : Colors.white;
  return (
    <Card elevation={2} className="eMed_Amt_card_div" sx={{ backgroundColor: bgcolor, width: "10vw", ml: "1vw" }}>
      <div className="eMed_Amt_card">
        <Typography sx={{ color: textColor, fontWeight: 600, fontSize: Amt.length > 10 ? "0.9dvw" : "1dvw", textAlign: "center" }} className="eMed_Amt_card_amount">
          {amount === undefined || amount === null ? (count ? "0" : `${CurrencySymbol} 0.00`) : count ? amount : `${CurrencySymbol} ${Number(amount).toFixed(2)}`}
        </Typography>
        <Typography sx={{ color: textColor }} className="eMed_Amt_card_label">{label}</Typography>
      </div>
    </Card>
  );
}
